
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class Overlay extends Vue {
  @Prop({ default: false }) showOverlay!: boolean;

  isOverlayShown = this.showOverlay;

  onOverlayClicked(evt: Event) {
    if (typeof $(evt.composedPath()[0]).attr('data-overlay') !== 'undefined') {
      this.isOverlayShown = false;
      this.$emit('hide-overlay');
    }
  }

  @Watch('showOverlay')
  overlayVisibilityChanged(newValue: boolean): void {
    this.isOverlayShown = newValue;
  }
}
